import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState, useContext } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Style from "./SuperyProductTable.module.scss";
import { tablePageNumber } from "../../../Utils/Context/SavePageNumberOfSuperyProducts";
import { PencilSquare, TrashFill } from "react-bootstrap-icons";
const SuperyProductTable = ({ data, showModal }) => {
  const { page, setPage } = useContext(tablePageNumber);
  console.log(page)
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const columns = [
    {
      title: "تصویر محصول",
      dataIndex: "productPic",
      key: "productPic",
      width: "10%",
      ...getColumnSearchProps("productPic", "نام محصول"),
      render: (text, record) => (
        <div className={Style.picHolder}>
          {record.new==="0"?
          <div className={Style.newAdded}></div>
          :
          null
          }
          <img
            src={`https://cdn.barest.ir/product/m/${
              record.key
            }.jpg?${randomNumberInRange(1, 1000000000000)}`}
            alt=""
          />
        </div>
      ),
    },
    {
      title: "نام محصول",
      dataIndex: "productName",
      key: "productName",
      width: "14%",
      ...getColumnSearchProps("productName", "نام محصول"),
    },
    {
      title: "نام برند",
      dataIndex: "brand",
      key: "brand",
      width: "14%",
      ...getColumnSearchProps("brand", "نام برند"),
    },
    {
      title: "دسته بندی ",
      dataIndex: "category",
      key: "category",
      width: "14%",
      ...getColumnSearchProps("category", "دسته بندی "),
    },
    {
      title: "بارکد اول",
      dataIndex: "barcode1",
      key: "barcode1",
      width: "14%",
      ...getColumnSearchProps("barcode1", "بارکد"),
    },
    {
      title: "بارکد دوم",
      dataIndex: "barcode2",
      key: "barcode2",
      width: "14%",
      ...getColumnSearchProps("barcode2", "بارکد"),
    },
    {
      title: "عملیات",
      dataIndex: "productName",
      key: "productName",
      width: "14%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => showModal(record, 1)}
            className={Style.orderBtn}
          >
            <PencilSquare />
          </button>
          <button
            onClick={() => showModal(record, 2)}
            className={Style.deleteBtn}
          >
            <TrashFill />
          </button>
        </div>
      ),
    },
  ];
  const onShowSizeChange = (page) => {
    setPage(page);
  };
  return (
    <div style={{ width: "100%" }}>
      <Table
        loading={data.length === 0 ? true : false}
        pagination={{
          pageSize: 50,
          onChange: (page) => onShowSizeChange(page),
          // current:isNaN(page)?1:page,
        }}
        columns={columns}
        dataSource={data}
        scroll={{x:1500, y: 500 }}
        size={"middle"}
        responsive={true}
      />
    </div>
  );
};

export default SuperyProductTable;
